var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inicio"},[_c('mq-layout',{attrs:{"mq":"sm"}},[_c('Informes')],1),_c('mq-layout',{attrs:{"mq":"md+"}},[_c('SliderMain'),_c('ArchiveInformes'),_c('SupportMain')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }